module.exports = __webpack_public_path__ + "KaTeX_Size3-Regular.84a8987c.ttf";